import React from "react";
import { makeStyles, SvgIcon } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    icon: {
        minWidth: "150px",
        height: "auto",
        width: "auto",
        ["@media (max-height: 815px)"]: {
            width: "60%",
        },
        maxWidth: "250px",
    },
}));

export default function LogoIcon(): JSX.Element {
    const classes = useStyles();
    return (
        <SvgIcon viewBox="0 0 278 276" className={ `${classes.icon} `}>
            <path
                fillRule="evenodd" clipRule="evenodd"
                d="M243.314 198.613C255.216 178.881 262.064 155.756 262.064 131.032C262.064 58.665 203.399 0 131.032 0C58.665 0
                    0 58.665 0 131.032C0 203.399 58.665 262.064 131.032 262.064C156.693 262.064 180.63 254.688 200.841 241.94L234.784
                    276L277.757 233.175L243.314 198.613Z" fill="#FFFFFE"
            />
            <path
                d="M85.3916 77.2944V53.002H176.672V66.9885L119.254 184.034H176.672V208.326H85.3916V192.867L141.338 77.2944H85.3916Z"
                fill="#343332" stroke="black" strokeWidth="0.5"
            />
        </SvgIcon>
    );
}
